import { render, staticRenderFns } from "./SchemeReviewMenu.vue?vue&type=template&id=129411d0&"
import script from "./SchemeReviewMenu.vue?vue&type=script&lang=js&"
export * from "./SchemeReviewMenu.vue?vue&type=script&lang=js&"
import style0 from "./SchemeReviewMenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports